import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entes-control',
  templateUrl: './entes-control.component.html',
  styleUrls: ['./entes-control.component.scss']
})
export class EntesControlComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
